// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import type PrimaryMailboxSearchScopeType from "../contract/PrimaryMailboxSearchScopeType";

export default function primaryMailboxSearchScopeType(data: PrimaryMailboxSearchScopeType): PrimaryMailboxSearchScopeType {
    const result: PrimaryMailboxSearchScopeType = {
        __type: "PrimaryMailboxSearchScopeType:#Exchange",
        ...data,
    };
    
    return result;
}
